import { UrlConfig } from '@shared/config/url.config';

export class UseConditionsConfig {
  private static baseUrl = UrlConfig.urlGestionCompte;

  public static get baseURL(): string {
    return UseConditionsConfig.baseUrl;
  }
  private static cgu: string = `${UseConditionsConfig.baseURL}utilisateur/cgu`;

  public static get valideCgu(): string {
    return UseConditionsConfig.cgu;
  }
}
